<template>
  <div>
    <h2>News items</h2>
    <v-btn :to="{ name: 'newsitemadd' }">
      <v-icon>add</v-icon>Add news item
    </v-btn>
    <v-data-table
      :pagination.sync="pagination"
      :total-items="newsCount"
      :loading="$apollo.loading"
      :headers="headers"
      :items="news"
      :footer-props="{ showFirstLastPage, showCurrentPage }"
      class="elevation-1"
    >
      <template v-slot:items="props">
        <tr>
          <td>
            <a @click="navigate(props.item)">{{ props.item.id }}</a>
          </td>
          <td style="white-space: pre-wrap">{{ props.item.body }}</td>
          <td>{{ props.item.timestamp | formatDate }}</td>
          <td>
            <EntityZ
              v-if="props.item.user"
              :entity="props.item.user"
              format="system"
            />
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import NEWS from "@/graphql/extras/News";
import NEWS_COUNT from "@/graphql/extras/NewsCount";
import EntityZ from "@/components/link/EntityZ";
export default {
  name: "News",
  metaInfo() {
    return {
      title: "News",
      titleTemplate: "%s - Message - Conveyancing Tracker",
      htmlAttrs: {
        lang: "en",
        amp: true
      }
    };
  },
  apollo: {
    news: {
      query: NEWS,
      variables() {
        return {
          first: this.firstRow,
          pagesize: this.pagination.rowsPerPage,
          sortby: this.pagination.sortBy,
          descending: this.pagination.descending
        };
      },
      fetchPolicy: "cache-and-network"
    },
    newsCount: {
      query: NEWS_COUNT,
      fetchPolicy: "cache-and-network"
    }
  },
  components: { EntityZ },
  computed: {
    firstRow() {
      const { page, rowsPerPage } = this.pagination;
      return (page - 1) * rowsPerPage;
    }
  },
  data() {
    return {
      entities: [],
      headers: [
        {
          text: "Id",
          value: "id"
        },
        {
          text: "Body",
          value: "body"
        },
        {
          text: "Timestamp",
          value: "timestamp"
        },
        {
          text: "User",
          value: "userid"
        }
      ],
      pagination: {
        sortBy: "timestamp",
        descending: true,
        page: 1,
        rowsPerPage: 10
      },
      showFirstLastPage: true,
      showCurrentPage: true
    };
  },
  methods: {
    navigate(item) {
      // console.log(item.articleId);
      this.$router.push({
        name: "newsitem",
        params: {
          id: item.id
        }
      });
    },
    search() {
      this.pagination.page = 1;
    }
  }
};
</script>
